import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TripTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { IBookedJourneyDetail, IBookingResponse, IJourneyStopLocation } from "../../../Orchestrator/Types/Index";
import { IJourneyLocationSelectionActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/JourneyLocationSelectionActionParams";
import { getJourneyStops } from "../../LogicActions/BookingDetail/GetBookingJourneyDetailAction";

export class JourneyLocationSelectionAction extends BaseAction<void, IJourneyLocationSelectionActionParams> {
  override async run(): Promise<void | null> {
    try {
      const { trainType = TripTypeEnum.OUT_BOUND, locationType, locationData, visible } = this.params!;

      let journeyPlannerStateAtom: IBookedJourneyDetail | null | undefined = getRecoilStateValue<IBookedJourneyDetail | null>("journeyPlannerStateAtom");
      if (!journeyPlannerStateAtom  || !Array.isArray(journeyPlannerStateAtom.journey_planner)) {
        journeyPlannerStateAtom = {
          journey_planner: []
        }
      }

      const newJourneyPointDetail: IJourneyStopLocation = {
        display_name: locationData.name,
        // TODO: work on this 
        cityName: '',
        // cityName: locationData.city || "",
        lat: locationData.coordinates[1],
        lon: locationData.coordinates[0],
      }

      let newJourneyPlannerState = structuredClone(journeyPlannerStateAtom || {});

      let isJourneyPresent = newJourneyPlannerState?.journey_planner?.find(journey => journey.direction === trainType);
      let journeyStops = getJourneyStops(trainType)
      if (isJourneyPresent && journeyStops) {
        newJourneyPlannerState.journey_planner = newJourneyPlannerState.journey_planner.map(journey => {
          if (journey.direction === trainType) {
            return {
              ...journeyStops,
              // ...journey,
              [locationType]: newJourneyPointDetail
            }
          }
          return journey;
        })
      } else {
        newJourneyPlannerState.journey_planner = [
          ...(newJourneyPlannerState?.journey_planner || []),
          {
            direction: trainType,
            [locationType]: newJourneyPointDetail
          }
        ]
      }

      updateRecoilState<IBookedJourneyDetail | null>("journeyPlannerStateAtom", newJourneyPlannerState)
      updateRecoilState("locationMapVisibleAtom", visible);
    } catch (error) {
      console.error("Error in JourneyLocationSelectionAction:", error);
    }
  }
}

export const journeyLocationSelectionAction = new JourneyLocationSelectionAction();
